module.exports = __webpack_public_path__ + "img/vue-js.247331c1.svg";